export default {
  "common.brand": "USFanslink",
  "nav.home": "Strona główna",
  "nav.spreadsheet": "Spreadsheet",
  "nav.creators": "Twórcy",
  "nav.reviews": "Opinie",
  "nav.shipping": "Wysyłka",
  "nav.coupons": "Kupony",
  "nav.guides": "Poradniki",
  "nav.shoppingGuide": "Poradnik zakupowy",

  "hero.badge": "Aktualne zasoby · Uporządkowane informacje",
  "hero.title": "USFans Spreadsheet – Poznaj twórców, opinie i zasoby",
  "hero.subtitle": "Znajdź przydatne informacje o USFans w jednym, uporządkowanym centrum zasobów. Poznaj USFans Spreadsheet, katalog twórców, opinie, poradniki wysyłkowe, kupony, informacje o magazynie i najnowsze aktualizacje.",
  "hero.ctaSpreadsheet": "usfans spreadsheet",
  "hero.ctaBuyNow": "buy it now",
  "hero.dropdownLabel": "Przejdź do kategorii",
  "hero.dropdownPlaceholder": "Wybierz kategorię…",
  "hero.trust": "Aktualne zasoby • Uporządkowane informacje • Nacisk na bezpieczeństwo • Łatwe przeglądanie",

  "categories.title": "Przeglądaj popularne kategorie",
  "categories.subtitle": "Przejdź prosto do produktów, których szukasz, w sklepie USFans spreadsheet.",

  "categories.shoes": "Buty",
  "categories.hoodies": "Bluzy/Swetry",
  "categories.tshirts": "Koszulki",
  "categories.jackets": "Kurtki",
  "categories.pants": "Spodnie/Shortsy",
  "categories.headwear": "Nakrycia głowy",
  "categories.sets": "Zestawy",
  "categories.underwear": "Bielizna",
  "categories.jersey": "Koszulki sportowe",
  "categories.accessories": "Akcesoria",
  "categories.bags": "Torby",
  "categories.belts": "Paski",
  "categories.perfumes": "Perfumy",
  "categories.other": "Inne artykuły",

  "content.eyebrow": "Centrum USFans Spreadsheet",
  "content.title": "Czym jest USFans Spreadsheet?",
  "content.p1": "USFans Spreadsheet to jedno, uporządkowane źródło, które gromadzi informacje związane z USFans w jednym miejscu. Zamiast szukać na wielu różnych stronach, odwiedzający znajdują twórców, opinie, szczegóły wysyłki, kupony i poradniki magazynowe zebrane w przejrzystą i łatwą do przeszukiwania strukturę.",
  "content.p2": "Sercem tego centrum jest katalog twórców. Każdy twórca jest wymieniony wraz ze swoją kategorią, dostępnymi informacjami i statusem ostatniej aktualizacji, dzięki czemu szybko zrozumiesz, kto jest aktywny i jakie treści oferuje.",
  "content.sub1": "Jak korzystać ze spreadsheetu",
  "content.p3": "Zacznij od wybrania kategorii z rozwijanego menu powyżej. Każda kategoria prowadzi do dedykowanej sekcji głównego sklepu, więc możesz przejść bezpośrednio do produktów, które Cię interesują — butów, koszulek sportowych, akcesoriów czy czegokolwiek innego z katalogu.",
  "content.sub2": "Opinie, wysyłka i kupony",
  "content.p4": "Poza katalogiem centrum porządkuje również praktyczne poradniki. Możesz czytać opinie, aby zrozumieć platformę, sprawdzić koszty wysyłki przed zamówieniem i szukać aktualnych informacji o kuponach i zniżkach. Wszystko jest zebrane, abyś nie musiał szukać sam.",
  "content.sub3": "Bezpieczeństwo i przejrzystość",
  "content.p5": "Ta strona to niezależne centrum zasobów i nie jest oficjalną witryną USFans. Skupiamy się na utrzymaniu uporządkowanych i łatwych do zweryfikowania informacji, abyś mógł przeglądać je z pewnością i przechodzić do głównego sklepu, gdy będziesz gotowy.",

  "article.ctaTitle": "Chcesz zobaczyć pełny obraz?",
  "article.ctaText": "Przeczytaj nasz kompletny przewodnik po USFans Spreadsheet, aby poznać katalog twórców, opinie, wysyłkę i nie tylko.",
  "article.ctaButton": "Przeczytaj pełny przewodnik",

  "articles.title": "Kluczowe przewodniki i artykuły USFans",
  "articles.subtitle": "Szczegółowe, niezależne przewodniki o recenzjach, wysyłce, kuponach, magazynie, bezpieczeństwie i nie tylko.",
  "articles.readMore": "Przeczytaj przewodnik",

  "footer.tagline": "Niezależne centrum zasobów z informacjami o USFans Spreadsheet.",
  "footer.navTitle": "Przeglądaj",
  "footer.categoriesTitle": "Kategorie",
  "footer.disclaimer": "USFanslink to niezależne centrum zasobów i nie jest powiązane z oficjalną witryną USFans.",
  "footer.rights": "Wszelkie prawa zastrzeżone."
};